export const BASE_PATH_SERVER = import.meta.env.VITE_API_URL;
export const API_PATH = import.meta.env.VITE_API_PATH;
export const PATH_GET_FILES = `${BASE_PATH_SERVER}public`;
export const APP_VERSION = import.meta.env.VITE_VERSION;
export const RELATIVE_API = '/api/v1';
